<template>
  <TooltipProvider>
    <Tooltip
      :open="!isClicked && !shouldHide"
    >
      <TooltipTrigger
        as-child
        v-bind="$attrs"
      >
        <a
          role="button"
          @click="onClick"
        >
          <slot />
        </a>
      </TooltipTrigger>
      <TooltipContent
        :side="side"
        class="tw:pointer-events-auto!"
        :class="{
          'tw:overflow-visible': !isClicked,
          'tw:animate-shake': !isClicked && isSideX,
          'tw:animate-shake-y': !isClicked && !isSideX,
        }"
        hide-when-detached
        @click="shouldHide = true"
      >
        {{ content }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup>
import { useLocalStorage } from '@vueuse/core'
import { onActivated, onDeactivated, ref } from 'vue'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shadcn/components/ui/tooltip'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  storeKey: {
    type: String,
    require: true,
  },
  content: {
    type: String,
    require: true,
  },
  side: {
    type: String,
    default: 'top',
  },
})

const emit = defineEmits(['click'])

const isSideX = props.side === 'left' || props.side === 'right'
const isClicked = useLocalStorage(props.storeKey, false)
const shouldHide = ref(false)

function onClick() {
  isClicked.value = true

  emit('click')
}

onDeactivated(() => {
  shouldHide.value = true
})

onActivated(() => {
  shouldHide.value = false
})
</script>
